import DasboardComponent from './Dashboard';

export const Dashboard = DasboardComponent;



// WEBPACK FOOTER //
// ./src/dashboard/index.js